// ----------------------------------------------------------------------
// Variant-value -> canonical grade key.
//
// Customers may see "Certified" or "Pristine" or "Pristine Condition"
// (rolling rename) — all must resolve to the `certified` tab/panel.
// Same map handles multi-word variants like "Brand New" / "Opened Box"
// that the previous .split(' ')[0] approach got wrong.
//
// Add new variant labels here as the catalogue evolves.
// ----------------------------------------------------------------------
const GRADE_ALIASES = {
  'pristine': 'certified',
  'pristine condition': 'certified',
  'certified': 'certified',
  'brand new': 'brand new',
  'opened box': 'brand new',
  'factory sealed': 'brand new',
  'sealed': 'brand new',
  'excellent': 'excellent',
  'good': 'good',
};

function resolveGrade(rawValue) {
  if (!rawValue) return null;
  const normalised = rawValue.toLowerCase().trim();

  // Exact match wins.
  if (GRADE_ALIASES[normalised]) return GRADE_ALIASES[normalised];

  // Substring fallback — catches things like "pristine (graded)" or
  // "good - 64gb" if the variant value ever picks up suffixes.
  for (const [alias, canonical] of Object.entries(GRADE_ALIASES)) {
    if (normalised.includes(alias)) return canonical;
  }

  return null;
}

class ContentTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.content-tabs__header li');
    this.selectedGrade = this.getAttribute('data-selected-grade');
    this.cards = this.querySelectorAll(`.content-tabs__cards`);

    Array.from(this.tabs).forEach(tab => {
      const tabGrade = tab.getAttribute('data-grade');
      const cards = this.querySelector(`.content-tabs__cards[data-grade="${tabGrade}"]`);

      if (this.selectedGrade && this.selectedGrade.includes(tabGrade)) {
        tab.classList.add('active', 'selected');
        if (cards) cards.classList.add('visible');
      }

      tab.addEventListener('click', () => {
        this.selectTab(tab);
      });
    });
  }

  connectedCallback() {
    if (document.querySelectorAll('input[name="Condition"]').length) {
      this.selectedConditionInput = document.querySelectorAll('input[name="Condition"]');
    } else if (document.querySelectorAll('input[name="Grading"]').length) {
      this.selectedConditionInput = document.querySelectorAll('input[name="Grading"]');
    }
    this.selectedConditionInput?.forEach(input => {
      input.addEventListener('swatch-change', () => this.handleExternalEvent(input));
    });
  }

  disconnectedCallback() {
    this.selectedConditionInput?.forEach(input => {
      input.removeEventListener('swatch-change', () => this.handleExternalEvent(input));
    });
  }

  handleExternalEvent(input) {
    if (!input.checked) return;

    const canonical = resolveGrade(input.value);
    if (!canonical) return; // unknown variant value — leave current tab alone

    const tab = this.querySelector(`[data-grade="${canonical}"]`);
    if (!tab) return; // no tab for this grade on this product

    this.setAttribute('data-selected-grade', canonical);
    this.selectTab(tab, true);
  }

  selectTab(tab, variantSelected) {
    const newCards = this.querySelector(`.content-tabs__cards[data-grade="${tab.getAttribute('data-grade')}"]`);

    // Tabs
    this.tabs.forEach(tab => {
      tab.classList.remove('active');
    });
    tab.classList.add('active');

    // if running from external event, add selected class to the tab
    if (variantSelected) {
      this.tabs.forEach(tab => {
        tab.classList.remove('selected');
      });
      tab.classList.add('selected');
    }

    // Cards
    [...this.cards].forEach(card => {
      card.classList.remove('visible');
    });
    if (newCards) newCards.classList.add('visible');
  }
}

customElements.define('content-tabs', ContentTabs);
